<!--
  WARNING!

  this file was automatically generated and should be updated using:

  ng g lazy-component extensions/custom-quickorder/shared/custom-quickorder-flyout/custom-quickorder-flyout.component.ts
-->
<ng-template #anchor></ng-template>
